"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = presetRule;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _ruleCart = _interopRequireDefault(require("./ruleCart"));

var _ruleSubject = _interopRequireDefault(require("./ruleSubject"));

function presetRule(extenstion) {
  return (0, _extends2.default)({
    cart: _ruleCart.default,
    subject: _ruleSubject.default
  }, extenstion);
}